export const DEFAULT_IMG = "/img/currency/placeholder.svg"
